import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FaRegTrashCan } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";

function CargosDestino({ onClose, valorActual, actualizarTarifa, concepto }) {
  const [colData, setColData] = useState([]);
  const [dueData, setDueData] = useState([]);

  // Cargar datos iniciales (simulados del back)
  useEffect(() => {
    if (valorActual) {
      setColData(valorActual.col || []);
      setDueData(valorActual.due || []);
    }
  }, [valorActual]);

  const agregarFila = (tipo) => {
    const nuevaFila = { v1: "", v2: "", v3: "", activo: false };

    if (tipo === "col") {
      setColData([...colData, nuevaFila]);
    } else {
      setDueData([...dueData, nuevaFila]);
    }
  };

  const eliminarFila = (tipo, index) => {
    if (tipo === "col") {
      setColData(colData.filter((_, i) => i !== index));
    } else {
      setDueData(dueData.filter((_, i) => i !== index));
    }
  };

  //Funcion ajustada para no aceptar letras
  const handleChange = (tipo, index, campo, valor) => {
    const data = tipo === "col" ? [...colData] : [...dueData];

    data[index][campo] = valor;

    tipo === "col" ? setColData(data) : setDueData(data);
  };

  const validarCampos = (data) => {
    return data.every(
      (fila) => fila.v1 !== "" && fila.v2 !== "" && fila.v3 !== "",
    );
  };

  //Funcion ajustada para no aceptar letras y para validar los campos vacios
  const handleActualizar = () => {
    if (!validarCampos(colData) || !validarCampos(dueData)) {
      Swal.fire({
        icon: "error",
        title: "Campos incompletos",
        text: "No se permiten campos vacíos",
      });
      return;
    }

    actualizarTarifa(concepto, {
      col: colData,
      due: dueData,
    });

    Swal.fire({
      title: "Éxito",
      text: "Cargos actualizados con éxito",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  const renderTabla = (data, tipo) => (
    <>
      <div className="table-responsive">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer text-center">
              <thead>
                <tr>
                  <th>De</th>
                  <th>A</th>
                  <th>Cargo</th>
                  <th>¿Porcentaje? %</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {data.map((fila, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        step="any"
                        onKeyDown={bloquearTeclas}
                        onInput={limpiarInput}
                        value={fila.v1}
                        onChange={(e) =>
                          handleChange(tipo, index, "v1", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        step="any"
                        onKeyDown={bloquearTeclas}
                        onInput={limpiarInput}
                        value={fila.v2}
                        onChange={(e) =>
                          handleChange(tipo, index, "v2", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        step="any"
                        onKeyDown={bloquearTeclas}
                        onInput={limpiarInput}
                        value={fila.v3}
                        onChange={(e) =>
                          handleChange(tipo, index, "v3", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={fila.activo}
                        onChange={(e) =>
                          handleChange(tipo, index, "activo", e.target.checked)
                        }
                      />
                    </td>
                    <td>
                      <FaRegTrashCan
                        style={{ cursor: "pointer", color: "black" }}
                        onClick={() => eliminarFila(tipo, index)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row">
          <div className="text-center mb-4">
            <button className="btnn" onClick={() => agregarFila(tipo)}>
              <FaPlus />
            </button>
          </div>
        </div>
      </div>
    </>
  );

  //Funcion para no aceptar letras
  const limpiarInput = (e) => {
    let valor = e.target.value;

    // quitar todo lo que no sea número o punto
    valor = valor.replace(/[^0-9.]/g, "");

    // evitar más de un punto decimal
    const partes = valor.split(".");
    if (partes.length > 2) {
      valor = partes[0] + "." + partes.slice(1).join("");
    }

    if (valor !== e.target.value) {
      e.target.value = valor;
    }
  };

  //Funcion para no aceptar letras
  const bloquearTeclas = (e) => {
    const teclasPermitidas = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (
      !/[0-9.]/.test(e.key) && // solo números y punto
      !teclasPermitidas.includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid">
        <div className="text-left">
          <div className="row mb-3">
            <label className="fw-bold d-block mb-2">CARGOS EN DESTINO</label>
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">COL (USD)</label>
            {/* Aqui van dos tablas con 5 columnas */}
            {renderTabla(colData, "col")}
          </div>

          <div className="row">
            <label className="fw-bold d-block mb-2">DUE (USD)</label>
            {/* Aqui van dos tablas con 5 columnas */}
            {renderTabla(dueData, "due")}
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CargosDestino;
